import { authSelectors } from "ducks/auth"
import { useMemo } from "react"
import { useSelector } from "react-redux"

export const useAcceptedTermsDate = () => {
  const acceptedTermsDate = useSelector(authSelectors.getAcceptedTermsDate)
  return useMemo(() => acceptedTermsDate ? new Date(acceptedTermsDate) : undefined, [acceptedTermsDate])
}